import type { Company } from "types/company";

type AccountTypeSource = Pick<Company, "isIndividual"> | null | undefined;

export function isIndividualAccount(source: AccountTypeSource): boolean {
  return Boolean(source?.isIndividual);
}

export function isCompanyAccount(source: AccountTypeSource): boolean {
  return !isIndividualAccount(source);
}

/** @deprecated Use isIndividualAccount */
export const isIndividualCompany = isIndividualAccount;
